import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Tag } from 'antd';

import Logger from '../../../../../lib/Logger';

const LearningModuleCategoryList = ({
  list,
  load,
  activeId,
  partnershipId,
  setSelectedTags,
  selectedTags,
  ...props
}) => {
  useEffect(() => {
    load(activeId, partnershipId);
  }, [activeId, partnershipId, load]);

  const onClose = (id) => {
    setSelectedTags(selectedTags.filter((x) => x !== id));
  };

  return (
    <Translation>
      {(t) => (
        <div className='learning-module-category-list'>
          {list.map((x) => (
            <Tag
              closable={selectedTags.indexOf(x.id) > -1}
              onClose={() => onClose(x.id)}
              className={
                selectedTags.indexOf(x.id) > -1 &&
                'learning-module-category-tag'
              }
              key={x.id}
              onClick={() => setSelectedTags([...selectedTags, x.id])}
            >
              {x.name}
            </Tag>
          ))}
        </div>
      )}
    </Translation>
  );
};

export default LearningModuleCategoryList;

Logger.log('silly', `LearningModuleCategoryList loaded.`);
